const DESKTOP_MQ = "(min-width: 1024px)"

function headerOffset() {
  const raw = getComputedStyle(document.documentElement).getPropertyValue("--site-header-height")
  const parsed = parseFloat(raw)
  return Number.isFinite(parsed) ? parsed * 16 : 72
}

export function scrollToListingCard(id) {
  const card = document.querySelector(`[data-listing-card][data-listing-id="${id}"]`)
  if (!card) return false

  document.querySelectorAll("[data-listing-card]").forEach((node) => {
    node.dataset.highlighted = node.dataset.listingId === id ? "true" : "false"
  })

  const top = card.getBoundingClientRect().top + window.scrollY - headerOffset() - 16
  window.scrollTo({ top: Math.max(0, top), behavior: "smooth" })
  return true
}

export function initListingsBrowsePage() {
  const shell = document.getElementById("listings-browse-shell")
  if (!shell) return

  const desktopMq = window.matchMedia(DESKTOP_MQ)
  let mapVisible = desktopMq.matches

  const openButtons = shell.querySelectorAll("[data-listings-map-open]")
  const closeButtons = shell.querySelectorAll("[data-listings-map-close]")

  const syncMapVisibility = () => {
    shell.classList.toggle("listings-browse__shell--map-visible", mapVisible)

    openButtons.forEach((button) => {
      button.hidden = mapVisible
      button.setAttribute("aria-expanded", mapVisible ? "true" : "false")
    })

    closeButtons.forEach((button) => {
      button.setAttribute("aria-expanded", mapVisible ? "true" : "false")
    })

    window.dispatchEvent(new CustomEvent("listings-browse:map-visibility", { detail: { open: mapVisible } }))
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      mapVisible = true
      syncMapVisibility()
    })
  })

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      mapVisible = false
      syncMapVisibility()
    })
  })

  desktopMq.addEventListener("change", (event) => {
    if (event.matches) mapVisible = true
    syncMapVisibility()
  })

  syncMapVisibility()

  shell.querySelectorAll("[data-listing-card]").forEach((card) => {
    card.addEventListener("mouseenter", () => {
      window.dispatchEvent(new CustomEvent("listings-browse:hover", { detail: { id: card.dataset.listingId } }))
    })
    card.addEventListener("mouseleave", () => {
      window.dispatchEvent(new CustomEvent("listings-browse:hover", { detail: { id: null } }))
    })
  })

  window.addEventListener("listings-browse:select", (event) => {
    const id = String(event.detail?.id ?? "")
    if (!id) return
    scrollToListingCard(id)
  })
}
